const defaultSettings: Preloaded = {
  settings: {
    languageCode: 'en',
  },
  urls: {
    vortex: '',
  },
  commonmenu: {
    feHost: '//cmfe-lite.lstdev.net',
    beHost: '//cm-lite.lstdev.net',
    registration: 'http://lite.lstdev.net/registration/?game=mk',
    profile: 'https://lite.lstdev.net/personal/',
    loader: '//cmfe-lite.lstdev.net/loader.min.js',
    login: '/auth/login/',
    logout: '/auth/logout/',
    token: '/auth/menu-token/',
    notificationsEnabled: false,
  },
  isStaging: false,
};

const preloaded: Preloaded = window.preloaded ? window.preloaded : defaultSettings;

export default preloaded;
